// TODO[MVP]: Add correct prod URL
export const API_ROOT = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : process.env.API_HOST || '';
